export const list = [
  "All",
  "Gaming",
  "Music",
  "Wildlife",
  "Rivers",
  "Podcasts",
  "Live",
  "Recently Uploaded",
  "New To You",
  "Cats",
  "Dinosaurs",
  "Mixes",
  "Hot Wheels",
  "Oceans",
];

export const OFFSET_LIVE_CHAT = 20;

export const YOUTUBE_API_URL =
  "https://youtube.googleapis.com/youtube/v3/videos?part=snippet%2CcontentDetails%2Cstatistics&chart=mostPopular&maxResults=50&regionCode=IN&key=" +
  process.env.REACT_APP_GOOGLE_API_SECOND_KEY;

export const YOUTUBE_SEARCH_API = "/complete/search?client=firefox&ds=yt&q=";

export const messages = [
  {
    name: "Aditya",
    message: "Hi, I'm new to chat! 😀",
  },
  {
    name: "Emma",
    message: "Hey there! Welcome to the chat! 😊",
  },
  {
    name: "Alex",
    message: "Hi Aditya! Nice to meet you. How's it going? 😄",
  },
  {
    name: "Sophia",
    message: "Greetings! If you have any questions, feel free to ask! 🌟",
  },
  {
    name: "Daniel",
    message: "Hello Aditya! Hope you're having a great day! 👋",
  },
  {
    name: "Olivia",
    message: "Hi new friend! Excited to chat with you! 🎉",
  },

  {
    name: "Liam",
    message: "Hey Aditya! What brings you to the chat today? 😊",
  },
  {
    name: "Ava",
    message: "Hello! Let's make this chat awesome! 💬",
  },
  {
    name: "Noah",
    message: "Hi Aditya! Ready for some interesting conversations? 🌐",
  },
  {
    name: "Isabella",
    message: "Hey! Feel free to share your thoughts and stories here! 📚",
  },
  {
    name: "William",
    message: "Greetings, Aditya! Ready for some engaging conversations? 🚀",
  },
  {
    name: "Sophie",
    message: "Hi there! Let's make this chat a memorable experience! 🌈",
  },
  {
    name: "Mason",
    message: "Hey Aditya! Looking forward to getting to know you better! 👋",
  },
  {
    name: "Ella",
    message: "Hello new friend! What's on your mind today? 💭",
  },
  {
    name: "James",
    message: "Hi Aditya! Chatting is always more fun with new friends! 🎊",
  },
  {
    name: "Charlotte",
    message: "Greetings from across the chat! Excited to connect! 🌍",
  },
  {
    name: "Benjamin",
    message: "Hey Aditya! Feel free to share your interests and hobbies! 🎮",
  },
  {
    name: "Amelia",
    message: "Hello! Let's make this chat a positive and uplifting space! 🌞",
  },
  {
    name: "Ethan",
    message: "Hi Aditya! Ready to embark on a chat adventure? 🚀",
  },
  {
    name: "Aria",
    message: "Greetings! Looking forward to some fun and interesting chats! 😄",
  },
  {
    name: "William",
    message: "Greetings, Aditya! Ready for some engaging conversations? 🚀",
  },
  {
    name: "Sophie",
    message: "Hi there! Let's make this chat a memorable experience! 🌈",
  },
  {
    name: "Mason",
    message: "Hey Aditya! Looking forward to getting to know you better! 👋",
  },
  {
    name: "Ella",
    message: "Hello new friend! What's on your mind today? 💭",
  },
  {
    name: "James",
    message: "Hi Aditya! Chatting is always more fun with new friends! 🎊",
  },
  {
    name: "Charlotte",
    message: "Greetings from across the chat! Excited to connect! 🌍",
  },
  {
    name: "Benjamin",
    message: "Hey Aditya! Feel free to share your interests and hobbies! 🎮",
  },
  {
    name: "Amelia",
    message: "Hello! Let's make this chat a positive and uplifting space! 🌞",
  },
  {
    name: "Ethan",
    message: "Hi Aditya! Ready to embark on a chat adventure? 🚀",
  },
  {
    name: "Aria",
    message: "Greetings! Looking forward to some fun and interesting chats! 😄",
  },
  {
    name: "William",
    message: "Greetings, Aditya! Ready for some engaging conversations? 🚀",
  },
  {
    name: "Sophie",
    message: "Hi there! Let's make this chat a memorable experience! 🌈",
  },
  {
    name: "Mason",
    message: "Hey Aditya! Looking forward to getting to know you better! 👋",
  },
  {
    name: "Ella",
    message: "Hello new friend! What's on your mind today? 💭",
  },
  {
    name: "James",
    message: "Hi Aditya! Chatting is always more fun with new friends! 🎊",
  },
  {
    name: "Charlotte",
    message: "Greetings from across the chat! Excited to connect! 🌍",
  },
  {
    name: "Benjamin",
    message: "Hey Aditya! Feel free to share your interests and hobbies! 🎮",
  },
  {
    name: "Amelia",
    message: "Hello! Let's make this chat a positive and uplifting space! 🌞",
  },
  {
    name: "Ethan",
    message: "Hi Aditya! Ready to embark on a chat adventure? 🚀",
  },
  {
    name: "Aria",
    message: "Greetings! Looking forward to some fun and interesting chats! 😄",
  },
  {
    name: "William",
    message: "Greetings, Aditya! Ready for some engaging conversations? 🚀",
  },
  {
    name: "Sophie",
    message: "Hi there! Let's make this chat a memorable experience! 🌈",
  },
  {
    name: "Mason",
    message: "Hey Aditya! Looking forward to getting to know you better! 👋",
  },
  {
    name: "Ella",
    message: "Hello new friend! What's on your mind today? 💭",
  },
  {
    name: "James",
    message: "Hi Aditya! Chatting is always more fun with new friends! 🎊",
  },
  {
    name: "Charlotte",
    message: "Greetings from across the chat! Excited to connect! 🌍",
  },
  {
    name: "Benjamin",
    message: "Hey Aditya! Feel free to share your interests and hobbies! 🎮",
  },
  {
    name: "Amelia",
    message: "Hello! Let's make this chat a positive and uplifting space! 🌞",
  },
  {
    name: "Ethan",
    message: "Hi Aditya! Ready to embark on a chat adventure? 🚀",
  },
  {
    name: "Aria",
    message: "Greetings! Looking forward to some fun and interesting chats! 😄",
  },
  {
    name: "William",
    message: "Greetings, Aditya! Ready for some engaging conversations? 🚀",
  },
  {
    name: "Sophie",
    message: "Hi there! Let's make this chat a memorable experience! 🌈",
  },
  {
    name: "Mason",
    message: "Hey Aditya! Looking forward to getting to know you better! 👋",
  },
  {
    name: "Ella",
    message: "Hello new friend! What's on your mind today? 💭",
  },
  {
    name: "James",
    message: "Hi Aditya! Chatting is always more fun with new friends! 🎊",
  },
  {
    name: "Charlotte",
    message: "Greetings from across the chat! Excited to connect! 🌍",
  },
  {
    name: "Benjamin",
    message: "Hey Aditya! Feel free to share your interests and hobbies! 🎮",
  },
  {
    name: "Amelia",
    message: "Hello! Let's make this chat a positive and uplifting space! 🌞",
  },
  {
    name: "Ethan",
    message: "Hi Aditya! Ready to embark on a chat adventure? 🚀",
  },
  {
    name: "Aria",
    message: "Greetings! Looking forward to some fun and interesting chats! 😄",
  },
  {
    name: "William",
    message: "Greetings, Aditya! Ready for some engaging conversations? 🚀",
  },
  {
    name: "Sophie",
    message: "Hi there! Let's make this chat a memorable experience! 🌈",
  },
  {
    name: "Mason",
    message: "Hey Aditya! Looking forward to getting to know you better! 👋",
  },
  {
    name: "Ella",
    message: "Hello new friend! What's on your mind today? 💭",
  },
  {
    name: "James",
    message: "Hi Aditya! Chatting is always more fun with new friends! 🎊",
  },
  {
    name: "Charlotte",
    message: "Greetings from across the chat! Excited to connect! 🌍",
  },
  {
    name: "Benjamin",
    message: "Hey Aditya! Feel free to share your interests and hobbies! 🎮",
  },
  {
    name: "Amelia",
    message: "Hello! Let's make this chat a positive and uplifting space! 🌞",
  },
  {
    name: "Ethan",
    message: "Hi Aditya! Ready to embark on a chat adventure? 🚀",
  },
  {
    name: "Aria",
    message: "Greetings! Looking forward to some fun and interesting chats! 😄",
  },
  {
    name: "William",
    message: "Greetings, Aditya! Ready for some engaging conversations? 🚀",
  },
  {
    name: "Sophie",
    message: "Hi there! Let's make this chat a memorable experience! 🌈",
  },
  {
    name: "Mason",
    message: "Hey Aditya! Looking forward to getting to know you better! 👋",
  },
  {
    name: "Ella",
    message: "Hello new friend! What's on your mind today? 💭",
  },
  {
    name: "James",
    message: "Hi Aditya! Chatting is always more fun with new friends! 🎊",
  },
  {
    name: "Charlotte",
    message: "Greetings from across the chat! Excited to connect! 🌍",
  },
  {
    name: "Benjamin",
    message: "Hey Aditya! Feel free to share your interests and hobbies! 🎮",
  },
  {
    name: "Amelia",
    message: "Hello! Let's make this chat a positive and uplifting space! 🌞",
  },
  {
    name: "Ethan",
    message: "Hi Aditya! Ready to embark on a chat adventure? 🚀",
  },
  {
    name: "Aria",
    message: "Greetings! Looking forward to some fun and interesting chats! 😄",
  },
  {
    name: "William",
    message: "Greetings, Aditya! Ready for some engaging conversations? 🚀",
  },
  {
    name: "Sophie",
    message: "Hi there! Let's make this chat a memorable experience! 🌈",
  },
  {
    name: "Mason",
    message: "Hey Aditya! Looking forward to getting to know you better! 👋",
  },
  {
    name: "Ella",
    message: "Hello new friend! What's on your mind today? 💭",
  },
  {
    name: "James",
    message: "Hi Aditya! Chatting is always more fun with new friends! 🎊",
  },
  {
    name: "Charlotte",
    message: "Greetings from across the chat! Excited to connect! 🌍",
  },
  {
    name: "Benjamin",
    message: "Hey Aditya! Feel free to share your interests and hobbies! 🎮",
  },
  {
    name: "Amelia",
    message: "Hello! Let's make this chat a positive and uplifting space! 🌞",
  },
  {
    name: "Ethan",
    message: "Hi Aditya! Ready to embark on a chat adventure? 🚀",
  },
  {
    name: "Aria",
    message: "Greetings! Looking forward to some fun and interesting chats! 😄",
  },
];
